import request from '@/utils/request'

// 订单发货  代办处
export function orderSends(data) {
    return request({
        url: '/order/orderSends',
        method: 'post',
        data
    })
}

// 订单收货  经销商
export function orderRecs(data) {
    return request({
        url: '/order/orderRecs',
        method: 'post',
        data
    })
}
